import * as React from "react";
const SvgFiRrNetworkAnalytic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-network-analytic_svg__a)">
      <path
        fill="#062147"
        d="m14.996 13.039 2.266-.22A3.5 3.5 0 0 0 20.5 15c1.93 0 3.5-1.57 3.5-3.5S22.43 8 20.5 8a3.5 3.5 0 0 0-3.432 2.829l-2.458.238a5 5 0 0 0-.957-1.456l1.839-2.776c.322.098.656.166 1.009.166 1.93 0 3.5-1.57 3.5-3.5A3.506 3.506 0 0 0 16.5 0C14.57 0 13 1.57 13 3.5c0 .851.317 1.621.824 2.229L12.029 8.44A4.95 4.95 0 0 0 10 8c-.724 0-1.407.162-2.029.44L6.176 5.729A3.47 3.47 0 0 0 7 3.5C7 1.571 5.43 0 3.5 0S0 1.571 0 3.501s1.57 3.5 3.5 3.5c.353 0 .687-.068 1.009-.166l1.839 2.776a4.97 4.97 0 0 0-1.347 3.39A4.95 4.95 0 0 0 6.026 16l-1.112 1.304a3.5 3.5 0 0 0-1.412-.303c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5c0-.7-.212-1.35-.567-1.897l1.094-1.283a4.94 4.94 0 0 0 2.473.681 4.95 4.95 0 0 0 2.948-.982l2.367 2.049a3.5 3.5 0 0 0-.315 1.434c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5a3.47 3.47 0 0 0-1.875.555l-2.338-2.023a4.94 4.94 0 0 0 .709-2.493zm5.504-3.038c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5m-4-8c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5M2 3.501c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5S2 4.328 2 3.501m1.5 18.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m3.5-9c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3m13 7.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5.673-1.5 1.5-1.5 1.5.673 1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-network-analytic_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNetworkAnalytic;
